import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardLayoutComponent } from 'src/app/shared/layout/dashboard-layout/component/dashboard-layout.component';
import {accessTokenGuard} from "../../core/guards/access-token.guard";
import {EAccessType} from "../../core/enums/access-type.enum";

const routes: Routes = [
  {
    path: '',
    component: DashboardLayoutComponent,
    canActivate: [accessTokenGuard],
    data: { allowedAccessToken: EAccessType.FAT,},
    children: [
      {
        path: 'subscriptions',
        loadChildren: () =>
          import('./modules/subscription/subscription.module').then(
            ({ SubscriptionModule }) => SubscriptionModule),
      },
      {
        path: 'providers',
        loadChildren: () =>
          import('./modules/providers/providers.module').then(
            ({ ProvidersModule }) => ProvidersModule),
      },
      {
        path: 'recipients',
        loadChildren: () =>
          import('./modules/recipients/recipients.module').then(
            ({ RecipientsModule }) => RecipientsModule),
      },
      {
        path: 'accounts',
        loadChildren: () =>
          import('./modules/accounts/accounts.module').then(
            ({ AccountsModule }) => AccountsModule),
      },
      {
        path: 'applications',
        loadChildren: () =>
          import('./modules/applications/applications.module').then(
            ({ ApplicationsModule }) => ApplicationsModule),
      },
       {
        path: 'transactions',
        loadChildren: () =>
          import('./modules/transactions/transactions.module').then(
            ({ TransactionsModule }) => TransactionsModule),
      },
       {
        path: 'masri-info-report',
        loadChildren: () =>
          import('./modules/masri-credit-report/masri-credit-report.module').then(
            ({ MasriCreditReportModule }) => MasriCreditReportModule),
      },
      {
        path: 'ratings',
        loadChildren: () =>
          import('./modules/ratings/ratings.module').then(
            ({ RatingsModule }) => RatingsModule),
      },
      {
        path: 'payments',
        loadChildren: () =>
          import('./modules/payments/payments.module').then(
            ({ PaymentsModule }) => PaymentsModule),
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ManagementRoutingModule { }
